export const DEFAULT_PLACEHOLDER = 'Not provided';
